export enum TripListType {
  BIKE_CARD = 'BIKE_CARD',
  BIKE_ITEM = 'BIKE_ITEM',
}
